"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH_UNIT = exports.SEGMENT = exports.CONTENT_POSITION = exports.BOX_COLOR = exports.BG_PRICE_COLOR = exports.BG_ICON_COLOR = exports.BG_COLOR = exports.BANNER_KIND = void 0;
const BANNER_KIND = exports.BANNER_KIND = {
  LAYOUT1: 'Layout1',
  LAYOUT1_FLOTANTE: 'Layout1_displayFloating',
  LAYOUT1_MARCA_MODELO: 'Layout1_marcaModelo',
  FULLPIC: 'FullPic',
  LAYOUT2_FUSION: 'Layout2_Fusion',
  LAYOUT2_DISTRIBUTIVA: 'Layout2_Distributiva',
  LAYOUT2_DISTRIBUTIVA_TEXTO: 'Layout2_Distributiva_Texto',
  LAYOUT3_FUSION: 'Layout3_Fusion',
  LAYOUT3_DISTRIBUTIVA: 'Layout3_Distributiva',
  LAYOUT4: 'Layout4',
  WHITEBOX: 'WhiteBox'
};
const CONTENT_POSITION = exports.CONTENT_POSITION = {
  RIGHT: 'right',
  LEFT: 'left',
  CENTER: 'center'
};
const WIDTH_UNIT = exports.WIDTH_UNIT = {
  PX: 'px',
  PERCENTAGE: '%',
  COLUMNS: 'columns'
};
const BOX_COLOR = exports.BOX_COLOR = {
  TRANSPARENT: 'transparent',
  BLUE: 'blue',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  RED: 'red',
  GREY: 'grey',
  GREY6: 'grey6',
  TRANSPARENT2BLACK: 'transparent2black',
  GREEN_MEDIUM: 'green-medium',
  BLUE_DARK: 'blue-dark',
  BLUE_LIGHT: 'blue-light',
  GREEN_LIGHT: 'green-light'
};
const SEGMENT = exports.SEGMENT = {
  GP: 'gp',
  EMP: 'emp'
};
const BG_COLOR = exports.BG_COLOR = {
  BLUE: 'blue',
  GREY1: 'grey1'
};
const BG_ICON_COLOR = exports.BG_ICON_COLOR = {
  TRANSPARENT: 'transparent',
  BLUE: 'blue',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREY6: 'grey6',
  RED: 'red',
  BLUE_DARK: 'blue-dark',
  GREEN_MEDIUM: 'green-medium',
  BLUE_LIGHT: 'blue-light',
  GREEN_LIGHT: 'green-light',
  TRANSPARENT2BLACK: 'transparent2black'
};
const BG_PRICE_COLOR = exports.BG_PRICE_COLOR = {
  GREY5: 'grey5',
  WHITE: 'white'
};

//# sourceMappingURL=constants.js.map